/**
 * View Countdown block
 * @module components/Blocks/Countdown/View
 */
import React from 'react';
import Body from './Body';

const View = (props) => {
  return <Body {...props} />;
};

export default View;
